import { helpers } from "./theme/helpers.js";
import { sliders } from "./theme/components/sliders.js";
import { tabs } from "./theme/components/tabs.js";
import { header } from "./theme/components/header.js";

window.theme = {
  globals: {
    isTouch: typeof window !== "undefined" && "ontouchstart" in window,
  },

  init: function () {
    var self = this;

    sliders.init();
    tabs.init();
    header.init();
  },
};

jQuery(document).ready(function ($) {
  theme.init();
});
